import { COMPARE } from '../utils/constants';

// Compare selections live in localStorage so they follow the customer from
// the PLP to the compare page. The keys match the previous theme's, so a
// list picked before the switch still works: its entries only carry id and
// handle (no title / image) and may hold a numeric id, so reads normalise
// the id to a string and callers treat title and image as optional. Storage
// access throws under blocked-cookies settings and sandboxed iframes, so
// every call is guarded and compare degrades to non-persistent.

const readCompareItems = () => {
  try {
    const items = JSON.parse(localStorage.getItem(COMPARE.ITEMS_KEY));
    if (!Array.isArray(items)) return [];
    const seenIds = new Set();
    return items
      .filter((item) => item?.id && item?.handle)
      .map((item) => ({ ...item, id: String(item.id) }))
      .filter((item) => !seenIds.has(item.id) && seenIds.add(item.id));
  } catch {
    return [];
  }
};

const writeCompareItems = (items) => {
  try {
    localStorage.setItem(COMPARE.ITEMS_KEY, JSON.stringify(items));
  } catch {
    // Persistence unavailable — the in-page state still works.
  }
};

const removeCompareItem = (id) => {
  const items = readCompareItems().filter((item) => item.id !== String(id));
  writeCompareItems(items);
  return items;
};

const readCompareMode = () => {
  try {
    return localStorage.getItem(COMPARE.MODE_KEY) === 'true';
  } catch {
    return false;
  }
};

const writeCompareMode = (isActive) => {
  try {
    if (isActive) {
      localStorage.setItem(COMPARE.MODE_KEY, 'true');
    } else {
      localStorage.removeItem(COMPARE.MODE_KEY);
    }
  } catch {
    // Persistence unavailable — the in-page toggle still works.
  }
};

export { readCompareItems, writeCompareItems, removeCompareItem, readCompareMode, writeCompareMode };
